import EditNote from './EditNote';

export default EditNote;
